var map = {
	"./BEST_PRACTICE.svg": "7833",
	"./BEST_PRACTICE_color.svg": "4057",
	"./BUSINESS_SOLUTION.svg": "644b",
	"./BUSINESS_SOLUTION_color.svg": "0683",
	"./IDEA.svg": "8caa",
	"./IDEA_color.svg": "88b4",
	"./PROJECT.svg": "344b",
	"./PROJECT_color.svg": "67db",
	"./attached.svg": "80f1",
	"./bars.svg": "cbd5",
	"./comments.svg": "12be",
	"./exit.svg": "a2ab",
	"./grey_star.svg": "dddf",
	"./grid_blue.svg": "ac09",
	"./grid_white.svg": "8902",
	"./lock.svg": "9619",
	"./map_blue.svg": "e883",
	"./map_white.svg": "a54b",
	"./rating_empty.svg": "43ee",
	"./rating_full.svg": "0ad9",
	"./rating_half.svg": "17d6",
	"./sliders.svg": "ff3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";